(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Cinematic-Video-Slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cinematic-video-slideshow')) {
    class CinematicVideoSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.cvs__slide'));
        if (!this.slides.length) return;

        this.dots = Array.from(this.querySelectorAll('.cvs__dot'));
        this.toggleBtn = this.querySelector('.cvs__toggle');
        this.prevBtn = this.querySelector('.cvs__arrow--prev');
        this.nextBtn = this.querySelector('.cvs__arrow--next');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        // Data saver / very slow connection: show posters only, never download video.
        const conn = navigator.connection;
        this.lite = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
        if (this.lite) this.classList.add('is-lite');

        this.isSlide = this.classList.contains('cvs--slide');
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.duration = parseInt(this.dataset.duration, 10) || 7000;
        this.advanceOnEnd = this.dataset.advanceOnEnd === 'true';

        this.current = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
        this.userPaused = this.reduced.matches;
        this.focusPaused = false;
        this.editorPaused = false;
        this.inView = !('IntersectionObserver' in window);
        this.elapsed = 0;
        this.last = 0;

        // Bound handlers (so they can be removed on disconnect)
        this.handlers = {
          prev: () => this.prev(),
          next: () => this.next(),
          toggle: () => this.togglePause(),
          keydown: (e) => {
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
            if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
          },
          focusin: (e) => {
            if (e.target.matches && e.target.matches(':focus-visible')) this.focusPaused = true;
          },
          focusout: () => {
            setTimeout(() => { if (!this.matches(':focus-within')) this.focusPaused = false; }, 0);
          },
          touchstart: (e) => {
            const t = e.touches[0];
            this.tx = t.clientX;
            this.ty = t.clientY;
          },
          touchend: (e) => {
            if (this.tx == null) return;
            const t = e.changedTouches[0];
            const dx = t.clientX - this.tx;
            const dy = t.clientY - this.ty;
            this.tx = null;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              if (dx < 0) this.next(); else this.prev();
            }
          },
          blockSelect: (e) => {
            const i = this.slides.indexOf(e.target);
            if (i < 0) return;
            this.editorPaused = true;
            this.goTo(i, undefined, true);
          },
          blockDeselect: () => { this.editorPaused = false; },
          mqChange: () => {
            this.slides.forEach((slide) => {
              const v = this.videoFor(slide);
              if (v && v.dataset.current) this.loadVideo(v);
            });
            this.playActive();
          },
          ended: (e) => {
            if (this.autoplay && this.advanceOnEnd && this.isRunning() &&
                e.target === this.videoFor(this.slides[this.current])) {
              this.next();
            }
          },
          frame: (e) => e.target.classList.add('has-frame'),
        };

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlers.prev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.handlers.next);
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handlers.toggle);
        this.dots.forEach((dot, i) => {
          dot._cvsClick = () => this.goTo(i);
          dot.addEventListener('click', dot._cvsClick);
        });
        this.addEventListener('keydown', this.handlers.keydown);
        this.addEventListener('focusin', this.handlers.focusin);
        this.addEventListener('focusout', this.handlers.focusout);
        if (this.slides.length > 1) {
          this.addEventListener('touchstart', this.handlers.touchstart, { passive: true });
          this.addEventListener('touchend', this.handlers.touchend, { passive: true });
        }
        this.addEventListener('shopify:block:select', this.handlers.blockSelect);
        this.addEventListener('shopify:block:deselect', this.handlers.blockDeselect);
        this.mq.addEventListener('change', this.handlers.mqChange);

        this.slides.forEach((slide) => {
          const v = this.videoFor(slide);
          if (!v) return;
          v.muted = true;
          v.loop = !(this.autoplay && this.advanceOnEnd);
          v.addEventListener('ended', this.handlers.ended);
          v.addEventListener('playing', this.handlers.frame);
          v.addEventListener('loadeddata', this.handlers.frame);
        });

        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.inView = entry.isIntersecting;
              if (entry.isIntersecting) {
                this.classList.add('is-inview');
                this.playActive();
              } else {
                this.pauseAllVideos();
              }
            });
          }, { threshold: 0.05 });
          this.viewObserver.observe(this);
        } else {
          this.classList.add('is-inview');
          this.playActive();
        }

        this.updatePausedUI();
        this.tick = this.tick.bind(this);
        if (this.autoplay) this.raf = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() {
        if (!this.handlers) return;
        cancelAnimationFrame(this.raf);
        clearTimeout(this.leaveTimer);
        clearTimeout(this.warmTimer);
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlers.prev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handlers.next);
        if (this.toggleBtn) this.toggleBtn.removeEventListener('click', this.handlers.toggle);
        this.dots.forEach((dot) => dot.removeEventListener('click', dot._cvsClick));
        this.removeEventListener('keydown', this.handlers.keydown);
        this.removeEventListener('focusin', this.handlers.focusin);
        this.removeEventListener('focusout', this.handlers.focusout);
        this.removeEventListener('touchstart', this.handlers.touchstart);
        this.removeEventListener('touchend', this.handlers.touchend);
        this.removeEventListener('shopify:block:select', this.handlers.blockSelect);
        this.removeEventListener('shopify:block:deselect', this.handlers.blockDeselect);
        this.mq.removeEventListener('change', this.handlers.mqChange);
      }

      /* ---------- Helpers ---------- */
      videoFor(slide) {
        return slide ? slide.querySelector('.cvs__video') : null;
      }

      isRunning() {
        return this.autoplay && !this.userPaused && !this.focusPaused && !this.editorPaused && this.inView;
      }

      loadPoster(slide) {
        if (!slide) return;
        slide.querySelectorAll('[data-srcset]').forEach((el) => {
          el.srcset = el.dataset.srcset;
          el.removeAttribute('data-srcset');
        });
      }

      // Runs once the current slide is showing: fetch the NEXT slide's poster
      // and only the first bytes (metadata) of its video. Nothing else.
      warmNext() {
        if (this.slides.length < 2) return;
        const nextSlide = this.slides[(this.current + 1) % this.slides.length];
        this.loadPoster(nextSlide);
        if (this.lite || !this.autoplay) return;
        const nv = this.videoFor(nextSlide);
        if (!nv || nv.dataset.current) return;
        const d = nv.dataset;
        const src = (this.mq.matches && d.srcMobile) || d.srcDesktop || d.srcMobile;
        if (!src) return;
        d.current = src;
        nv.preload = 'metadata';
        nv.src = src;
      }

      loadVideo(video) {
        if (this.lite) return;
        const d = video.dataset;
        const src = (this.mq.matches && d.srcMobile) || d.srcDesktop || d.srcMobile;
        if (!src || d.current === src) return;
        d.current = src;
        video.classList.remove('has-frame');
        video.preload = 'auto';
        video.src = src;
        video.load();
      }

      playActive() {
        const slide = this.slides[this.current];
        this.loadPoster(slide);
        if (!this.inView) return;

        clearTimeout(this.warmTimer);
        const v = this.videoFor(slide);
        // Nothing is downloaded while paused (or for reduced-motion visitors).
        if (v && !this.userPaused && !this.lite) {
          this.loadVideo(v);
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
          // Warm the next slide only after this video is actually playing,
          // so it never competes with the video on screen.
          if (!v.paused && v.readyState > 2) {
            this.warmTimer = setTimeout(() => this.warmNext(), 1500);
          } else {
            v.addEventListener('playing', () => {
              this.warmTimer = setTimeout(() => this.warmNext(), 1500);
            }, { once: true });
          }
        } else {
          this.warmTimer = setTimeout(() => this.warmNext(), 1500);
        }
      }

      pauseAllVideos() {
        this.slides.forEach((slide) => {
          const v = this.videoFor(slide);
          if (v && !v.paused) v.pause();
        });
      }

      /* ---------- Navigation ---------- */
      prev() { this.goTo(this.current - 1, -1); }
      next() { this.goTo(this.current + 1, 1); }

      goTo(index, dir, instant) {
        const n = this.slides.length;
        if (n < 2) return;
        index = ((index % n) + n) % n;
        if (index === this.current) return;
        if (dir === undefined) dir = index > this.current ? 1 : -1;

        // Finish any transition still in progress
        clearTimeout(this.leaveTimer);
        this.slides.forEach((s) => {
          s.classList.remove('is-leaving');
        });

        const prevSlide = this.slides[this.current];
        const nextSlide = this.slides[index];
        this.loadPoster(nextSlide);
        const animate = !instant && !this.reduced.matches;

        const pv = this.videoFor(prevSlide);
        if (pv) pv.pause();

        if (this.isSlide) {
          if (animate) {
            nextSlide.style.transition = 'none';
            nextSlide.style.transform = 'translateX(' + dir * 100 + '%)';
            void nextSlide.offsetWidth;
            nextSlide.style.transition = '';
            nextSlide.style.transform = 'translateX(0)';
            prevSlide.style.transform = 'translateX(' + -dir * 100 + '%)';
          } else {
            nextSlide.style.transform = 'translateX(0)';
          }
        }

        prevSlide.classList.remove('is-active');
        if (animate) prevSlide.classList.add('is-leaving');
        prevSlide.setAttribute('aria-hidden', 'true');
        prevSlide.inert = true;

        nextSlide.classList.add('is-active');
        nextSlide.removeAttribute('aria-hidden');
        nextSlide.inert = false;

        if (animate) {
          this.leaveTimer = setTimeout(() => {
            prevSlide.classList.remove('is-leaving');
            const v = this.videoFor(prevSlide);
            if (v) v.currentTime = 0;
          }, 950);
        }

        if (this.dots.length) {
          const oldDot = this.dots[this.current];
          if (oldDot) {
            oldDot.removeAttribute('aria-current');
            oldDot.style.setProperty('--progress', 0);
          }
          const newDot = this.dots[index];
          if (newDot) newDot.setAttribute('aria-current', 'true');
        }

        this.current = index;
        this.elapsed = 0;

        const nv = this.videoFor(nextSlide);
        if (nv && nv.dataset.current) {
          try { nv.currentTime = 0; } catch (e) {}
        }
        this.playActive();
      }

      /* ---------- Autoplay loop (drives progress bars too) ---------- */
      tick(t) {
        const dt = this.last ? Math.min(t - this.last, 100) : 0;
        this.last = t;

        if (this.isRunning()) {
          const v = this.videoFor(this.slides[this.current]);
          let progress;
          if (this.advanceOnEnd && v && v.dataset.current && v.duration && isFinite(v.duration)) {
            progress = v.currentTime / v.duration;
          } else {
            this.elapsed += dt;
            progress = this.elapsed / this.duration;
            if (progress >= 1) {
              this.next();
              progress = 0;
            }
          }
          const dot = this.dots[this.current];
          if (dot) dot.style.setProperty('--progress', Math.min(progress, 1).toFixed(4));
        }
        this.raf = requestAnimationFrame(this.tick);
      }

      /* ---------- Play / pause ---------- */
      togglePause() {
        this.userPaused = !this.userPaused;
        if (this.userPaused) {
          this.pauseAllVideos();
        } else {
          this.playActive();
        }
        this.updatePausedUI();
      }

      updatePausedUI() {
        this.classList.toggle('is-paused', this.userPaused);
        if (!this.toggleBtn) return;
        this.toggleBtn.setAttribute(
          'aria-label',
          this.userPaused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause
        );
      }
    }
    customElements.define('cinematic-video-slideshow', CinematicVideoSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cinematic-video-banner')) {
    class CinematicVideoBanner extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.cvb__video');
        this.toggleBtn = this.querySelector('.cvb__toggle');
        this.scrollBtn = this.querySelector('.cvb__scroll');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reduced.matches;
        this.inView = false;

        this.onScrollClick = this.onScrollClick.bind(this);
        if (this.scrollBtn) this.scrollBtn.addEventListener('click', this.onScrollClick);

        // In-view observer: starts entrance animation, pauses video off-screen.
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.inView = entry.isIntersecting;
              if (entry.isIntersecting) this.classList.add('is-inview');
              if (!this.video || !this.video.dataset.current) return;
              if (entry.isIntersecting) {
                if (!this.userPaused) this.play();
              } else {
                this.video.pause();
              }
            });
          }, { threshold: 0.05 });
          this.viewObserver.observe(this);
        } else {
          this.classList.add('is-inview');
          this.inView = true;
        }

        if (!this.video) return;
        this.video.muted = true;

        this.onFrame = () => this.classList.add('has-frame');
        this.onPlay = () => this.setPausedUI(false);
        this.onPause = () => { if (this.userPaused) this.setPausedUI(true); };
        this.onToggle = () => this.toggle();
        this.onMqChange = () => this.setSource();

        this.video.addEventListener('playing', this.onFrame);
        this.video.addEventListener('loadeddata', this.onFrame);
        this.video.addEventListener('play', this.onPlay);
        this.video.addEventListener('pause', this.onPause);
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.onToggle);
        this.mq.addEventListener('change', this.onMqChange);

        if (this.userPaused) this.setPausedUI(true);

        if (this.dataset.lazy === 'true' && 'IntersectionObserver' in window) {
          this.lazyObserver = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.lazyObserver.disconnect();
              this.setSource();
            }
          }, { rootMargin: '300px 0px' });
          this.lazyObserver.observe(this);
        } else {
          this.setSource();
        }
      }

      disconnectedCallback() {
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.lazyObserver) this.lazyObserver.disconnect();
        if (this.scrollBtn) this.scrollBtn.removeEventListener('click', this.onScrollClick);
        if (!this.video) return;
        this.video.removeEventListener('playing', this.onFrame);
        this.video.removeEventListener('loadeddata', this.onFrame);
        this.video.removeEventListener('play', this.onPlay);
        this.video.removeEventListener('pause', this.onPause);
        if (this.toggleBtn) this.toggleBtn.removeEventListener('click', this.onToggle);
        this.mq.removeEventListener('change', this.onMqChange);
      }

      setSource() {
        const d = this.video.dataset;
        const src = (this.mq.matches && d.srcMobile) || d.srcDesktop || d.srcMobile;
        if (!src || d.current === src) return;
        d.current = src;
        this.classList.remove('has-frame');
        this.video.src = src;
        this.video.load();
        if (!this.userPaused && (this.inView || !this.viewObserver)) this.play();
      }

      play() {
        const p = this.video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }

      toggle() {
        if (!this.video.dataset.current) this.setSource();
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }

      setPausedUI(paused) {
        this.classList.toggle('is-paused', paused);
        if (!this.toggleBtn) return;
        this.toggleBtn.setAttribute(
          'aria-label',
          paused ? this.toggleBtn.dataset.labelPlay : this.toggleBtn.dataset.labelPause
        );
      }

      onScrollClick() {
        const section = this.closest('.shopify-section');
        const next = section && section.nextElementSibling;
        const target = next || null;
        const behavior = this.reduced.matches ? 'auto' : 'smooth';
        if (target) {
          target.scrollIntoView({ behavior, block: 'start' });
        } else {
          window.scrollTo({ top: this.getBoundingClientRect().bottom + window.scrollY, behavior });
        }
      }
    }
    customElements.define('cinematic-video-banner', CinematicVideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
